<template>
  <div class="role-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">角色管理</span>
      </div>
      <el-button type="primary" @click="openAddDialog">
        <i class="el-icon-plus"></i> 新增角色
      </el-button>
    </div>

    <div class="role-grid">
      <el-card v-for="role in roles" :key="role.roleCode" class="role-card">
        <div class="role-header">
          <div class="role-icon" :style="{ background: role.color }">
            <i :class="role.icon"></i>
          </div>
          <div class="role-info">
            <div class="role-name">{{ role.roleName }}</div>
            <div class="role-code">{{ role.roleCode }}</div>
          </div>
          <el-tag :type="role.status === 'NORMAL' ? 'success' : 'info'" size="small">
            {{ role.status === 'NORMAL' ? '启用' : '禁用' }}
          </el-tag>
        </div>
        <div class="role-desc">{{ role.description }}</div>
        <div class="role-stats">
          <span><i class="el-icon-user"></i> {{ role.userCount }} 人</span>
          <span><i class="el-icon-menu"></i> {{ role.permissionCount }} 个权限</span>
        </div>
        <div class="role-actions">
          <el-button type="text" @click="openEditDialog(role)">编辑</el-button>
          <el-button type="text" @click="goToPermissionConfig(role)">权限配置</el-button>
          <el-button type="text" @click="toggleStatus(role)">
            {{ role.status === 'NORMAL' ? '禁用' : '启用' }}
          </el-button>
        </div>
      </el-card>
    </div>

    <!-- 新增/编辑角色弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="form.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色代码" prop="roleCode">
          <el-input v-model="form.roleCode" placeholder="请输入角色代码（英文大写）" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" v-model="form.description" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="NORMAL">启用</el-radio>
            <el-radio label="DISABLED">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRole">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getRoleListWithCount, addRole, updateRole, deleteRole } from '@/api/rolePermissionApi'

export default {
  name: 'RoleManage',
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '新增角色',
      isEdit: false,
      currentRole: null,
      form: {
        roleName: '',
        roleCode: '',
        description: '',
        status: 'NORMAL'
      },
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        roleCode: [
          { required: true, message: '请输入角色代码', trigger: 'blur' },
          { pattern: /^[A-Z][A-Z0-9_]*$/, message: '角色代码必须是大写字母开头', trigger: 'blur' }
        ]
      },
      roles: []
    }
  },
  mounted() {
    this.loadRoles()
  },
  methods: {
    async loadRoles() {
      try {
        const res = await getRoleListWithCount()
        this.roles = res.map(r => ({
          ...r,
          icon: r.icon || 'el-icon-s-custom',
          color: r.color || '#909399',
          userCount: r.userCount || 0,
          permissionCount: r.permissionCount || 0
        }))
      } catch (e) {
        console.error('加载角色列表失败', e)
      }
    },
    goBack() {
      this.$router.push('/home/workbench')
    },
    goToPermissionConfig(role) {
      this.$router.push({ path: '/home/permission-config', query: { role: role.roleCode } })
    },
    openAddDialog() {
      this.isEdit = false
      this.dialogTitle = '新增角色'
      this.form = {
        roleName: '',
        roleCode: '',
        description: '',
        status: 'NORMAL'
      }
      this.dialogVisible = true
    },
    openEditDialog(role) {
      this.isEdit = true
      this.dialogTitle = '编辑角色'
      this.form = { ...role }
      this.dialogVisible = true
    },
    async saveRole() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isEdit) {
              await updateRole(this.form)
              this.$message.success('修改成功')
            } else {
              await addRole(this.form)
              this.$message.success('添加成功')
            }
            this.dialogVisible = false
            this.loadRoles()
          } catch (e) {
            this.$message.error(e.message || '操作失败')
          }
        }
      })
    },
    async toggleStatus(role) {
      const action = role.status === 'NORMAL' ? '禁用' : '启用'
      try {
        await this.$confirm(`确定${action}角色"${role.roleName}"？`, '提示', { type: 'warning' })
        role.status = role.status === 'NORMAL' ? 'DISABLED' : 'NORMAL'
        await updateRole({ roleCode: role.roleCode, roleName: role.roleName, description: role.description, status: role.status })
        this.$message.success(`${action}成功`)
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '操作失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.role-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.role-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 15px;
  margin: 15px 20px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
}

.role-card {
  border-radius: 4px;
}

.role-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.role-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.role-icon i {
  font-size: 24px;
  color: #fff;
}

.role-info {
  flex: 1;
}

.role-name {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.role-code {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.role-desc {
  font-size: 13px;
  color: #606266;
  margin-bottom: 12px;
  line-height: 1.5;
}

.role-stats {
  display: flex;
  gap: 20px;
  font-size: 12px;
  color: #909399;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.role-stats span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.role-actions {
  display: flex;
  justify-content: space-between;
}

</style>
